/**
 * sync/api-bases.js — resolucion en RUNTIME de las bases de URL del backend (deuda de tuning
 * 2026-06: antes duplicado verbatim en los fetchers de pull).
 *
 * src/api trae config()/Quasar; importarlo ESTATICO romperia la importabilidad de los modulos de
 * sync en vitest. Por eso el import es dinamico y solo se invoca dentro de los fetchers (que los
 * gates no ejercitan con la base real — el fake transport ignora la URL). En produccion resuelve:
 *   - gql: GRAPHQL_URL = config('gql.url') + 'api/'  (los 9 catalogos)
 *   - old: URL         = config('api.url') + 'api/'  (backend VIEJO, SOLO c_tags gated)
 */
export async function apiBases () {
  const mod = await import('src/api')
  const API = mod.default || mod
  return { gql: API.GRAPHQL_URL, old: API.URL }
}
